import { Route, Routes } from "react-router-dom";
import EspecializacionAlcantarillado from "../../src/newPages/posgrados/EspecializacionAlcantarillado";
import EspecializacionVias from "../../src/newPages/posgrados/EspecializacionVias";
import EspecializacionGeoinformacion from "../../src/newPages/posgrados/EspecializacionGeoinformacion";
import EspecializacionLogistica from "../../src/newPages/posgrados/EspecializacionLogistica";
import EspecializacionTributacion from "../../src/newPages/posgrados/EspecializacionTributacion";
import DoctoradoQuimica from "../../src/newPages/posgrados/DoctoradoQuimica";
import MaestriaAnalisisBiologico from "../../src/newPages/posgrados/MaestriaAnalisisBiologico";
import MaestriaEducacionCurriculo from "../../src/newPages/posgrados/MaestriaEducacionCurriculo";
import MaestriaDatos from "../newPages/posgrados/MaestriaDatos";
import EspecializacionBlockChain from "../newPages/posgrados/EspecializacionBlockChain";
import MaestriaDerechoAdministrativo from "../newPages/posgrados/MaestriaDerechoAdministrativo";
import MaestriaLiteratura from "../newPages/posgrados/MaestriaLiteratura";
import MaestriaGestionFinanciera from "../newPages/posgrados/MaestriaGestionFinanciera";
import MaestriaDerechoTributario from "../newPages/posgrados/MaestriaDerechoTributario";
import EspecializacionGeotecnia from "../newPages/posgrados/EspecializacionGeotecnia";
import EspecializacionMedicinaFamiliar from "../newPages/posgrados/EspecializacionMedicinaFamiliar";
import MaestriaBioeconomia from "../newPages/posgrados/MaestriaBioeconomia";
import EspecializacionMecanicaSuelos from "../newPages/posgrados/EspecializacionMecanicaSuelos";
import MaestriaComunicacionEstrategica from "../newPages/posgrados/MaestriaComunicacionEstrategica";
import MaestriaGeologia from "../newPages/posgrados/MaestriaGeologia";
import MaestriaFarmaciaAsistencial from "../newPages/posgrados/MaestriaFarmaciaAsistencial";
import EspecializacionPatrimonioPaleontologico from "../newPages/posgrados/EspecializacionPatrimonioPaleontologico";
import MaestriaCienciasAmbientales from "../newPages/posgrados/MaestriaCienciasAmbientales";
import MaestriaEducacionInclusiva from "../newPages/posgrados/MaestriaEducacionInclusiva";
import MaestriaInvestigacionEducacion from "../newPages/posgrados/MaestriaInvestigacionEducacion";
import MaestriaCienciasPoliticas from "../newPages/posgrados/MaestriaCienciasPoliticas";
import EspecializacionImageonologia from "../newPages/posgrados/EspecializacionImageonologia";
import MaestriaRecursosNaturales from "../newPages/posgrados/MaestriaRecursosNaturales";
import MaestriaTalentoHumano from "../newPages/posgrados/MaestriaTalentoHumano";
import MaestriaDireccionFinanciera from "../newPages/posgrados/MaestriaDireccionFinanciera";
import MaestriaGestionEmpresarial from "../newPages/posgrados/MaestriaGestionEmpresarial";
import MaestriaMarketing from "../newPages/posgrados/MaestriaMarketing";
import MaestriaAdministracionMBA from "../newPages/posgrados/MaestriaAdministracionMBA";
import MaestriaTransformacionDigital from "../newPages/posgrados/MaestriaTransformacionDigital";
import MaestriaGestionProyectos from "../newPages/posgrados/MaestriaGestionProyectos";
import MaestriaAuditoria from "../newPages/posgrados/MaestriaAuditoria";
import MaestriaIAAplicada from "../newPages/posgrados/MaestriaIAAplicada";
import MaestriaIndustria from "../newPages/posgrados/MaestriaIndustria";
import MaestriaPlanificacionTerritorio from "../newPages/posgrados/MaestriaPlanificacionTerritorio";

function RoutesPosgrados() {
  return (
    <>
      <Routes>
       
        <Route
          path="/maestria-datos"
          element={<MaestriaDatos></MaestriaDatos>}
        />

     
       
    
        <Route
          path="/maestria-gestion-proyectos"
          element={<MaestriaGestionProyectos></MaestriaGestionProyectos>}
        />
      
       
     
      </Routes>{" "}
    </>
  );
}

export default RoutesPosgrados;
